import classNames from "classnames";
import { LocalStorage } from "../../models/LocalStorage";
import { validate } from "../../utils/validate";
import { DComponent } from "../DComponent";
import { GLOBAL_CONSTANTS } from "../../global/constants";

export default class FilterForm extends DComponent {
  constructor({
    parent,
    id,
    disabled = false,
    onInput = (value) => { },
    onChange = (value) => { },
    onBlur = (value) => { },
    onDropdownOpen = () => { },
    iconPrefix,
    iconPrefixActive,
    placeholderText,
    placeholderI18n,
    options,
    currentValue,
    minHeightDropDown,
    lang = LocalStorage.getLanguage(),
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("FilterForm", {
        "has-icon": iconPrefix,
      }),
    });
    this.disabled = disabled;
    this.options = options;
    this.onInput = onInput;
    this.onChange = onChange;
    this.onBlur = onBlur;
    this.onDropdownOpen = onDropdownOpen;
    this.iconPrefix = iconPrefix;
    this.iconPrefixActive = iconPrefixActive;
    this.placeholderText = placeholderText;
    this.placeholderI18n = placeholderI18n;
    this.minHeightDropDown = minHeightDropDown;
    this.selectField = undefined;
    this.currentValue = currentValue;
    this.lang = lang;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "FilterForm");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.setupField();
  }

  setupField(isReset = false) {
    if (isReset && this.selectField) {
      this.selectField.destroy();
    }

    let onDropdownOpen = this.onDropdownOpen, onBlur = this.onBlur, onChange = this.onChange, lang = this.lang;
    this.selectField = $(".select-component", this.element).selectize({
      searchField: ['value', 'label'],
      options: this.options,
      onDropdownOpen: function () {
        this.latest = this.getValue() || this.latest;
        this.$input.get(0).selectize.clear(true);
        if (typeof (onDropdownOpen) === "function") {
          onDropdownOpen();
        }
      },
      onBlur: function (e) {
        if (this.getValue() === '') {
          this.setValue(this.latest);
          if (typeof (onBlur) === "function") {
            onBlur(e);
          }
        }
      },
      onChange: (value) => {
        if (value && value !== this.selectField.latest) {
          validate({ selector: $("select", this.element), ignore: true, type: GLOBAL_CONSTANTS.INPUT_TYPE.SELECT });
          if (typeof (onChange) === "function") {
            onChange(value);
          }
          this.currentValue = value;
          value ? $(".selectize-input", this.element).addClass("has-value") : $(".selectize-input", this.element).removeClass("has-value");
        }
      },
      render: {
        item: function (item, escape) {
          let style = `
              background-position: ${item.col * -48}px ${item.row * -48}px;
          `;
          return `
            <div class="option-item${!item.noCompactSvg ? " compact" : ""}" row="${item.row || 0}" col="${item.col || 0}">
              ${item.icon ?
              `
                <span class="icon-option" style="background-image:url(${escape(item.icon)}); ${style}"></span>
                <span class="icon-option active" style="background-image:url(${escape(item.iconActive || item.icon)}); ${style}"></span>
              `
              : ""}
              ${item.labelI18n ?
                `<div class="label-item" data-i18n="${item.labelI18n}">${$.i18n(escape(item.labelI18n))}</div>`
                :
                `
                  <div class="label-item en${lang !== "en" ? " hide" : ""}">${escape(item.label)}</div>
                  <div class="label-item vi${lang !== "vi" ? " hide" : ""}">${item.label_vi ? escape(item.label_vi) : escape(item.label)}</div>
                `}
            </div>
          `;
        },
        option: function (item, escape) {
          let style = `
              background-position: ${item.col * -48}px ${item.row * -48}px;
          `;
          return `
            <div class="option-item${!item.noCompactSvg ? " compact" : ""}" row="${item.row || 0}" col="${item.col || 0}">
              ${item.icon ?
              `
                <span class="icon-option" style="background-image:url(${escape(item.icon)}); ${style}"></span>
                <span class="icon-option active" style="background-image:url(${escape(item.iconActive || item.icon)}); ${style}"></span>
              `
              : ""}
              ${item.labelI18n ?
              `<div class="label-item" data-i18n="${item.labelI18n}">${$.i18n(escape(item.labelI18n))}</div>`
              :
              `
                <div class="label-item en${lang !== "en" ? " hide" : ""}">${escape(item.label)}</div>
                <div class="label-item vi${lang !== "vi" ? " hide" : ""}">${item.label_vi ? escape(item.label_vi) : escape(item.label)}</div>
              `}
              </div >
            `;
        }
      },
    })[0].selectize;

    if (this.currentValue) {
      this.setValue(this.currentValue, true);
    }

    this.setDisabled(this.disabled);

    if (this.placeholderI18n) {
      $("input", this.element).attr("data-i18n", `[placeholder]${this.placeholderI18n}`);
      $("input", this.element).attr("placeholder", $.i18n(this.placeholderI18n));
    }
    if (this.placeholderText) {
      $("input", this.element).attr("placeholder", this.placeholderText);
    }

    if (this.iconPrefix) {
      $(".selectize-input", this.element).append(`
            <img class="icon-prefix" src='${this.iconPrefix}' alt='icon-prefix' />
            <img class="icon-prefix active" src='${this.iconPrefixActive || this.iconPrefix}' alt='icon-prefix' />
          `);
    }

    if (this.minHeightDropDown) {
      $(".selectize-dropdown", this.element).css("min-height", this.minHeightDropDown);
    }

    $("input", this.element).off("focus");
    $('input', this.element).focus(() => {
      this.element.addClass('focus');
    });

    $("input", this.element).off("blur");
    $('input', this.element).blur(() => {
      this.element.removeClass('focus');
    });

    $("input", this.element).off("click");
    $("input", this.element).on("click", () => {
      if (this.element.find(".icon-prefix").length === 0 && this.iconPrefix) {
        $(".selectize-input", this.element).append(`
            <img class="icon-prefix" src='${this.iconPrefix}' alt='icon-prefix' />
              <img class="icon-prefix active" src='${this.iconPrefixActive || this.iconPrefix}' alt='icon-prefix' />
          `);
      }
    });

    $("input", this.element).off("change");
    $("input", this.element).on("change", () => {
      typeof this.onInput == "function" && this.onInput(this.getValue());
      $('input', this.element).blur();
    });
  }

  addOption(options = []) {
    this.options = options;
    this.selectField.clearOptions();
    if (!options.length) return;
    this.selectField.addOption(options);
  }

  getItem() {
    if (this.getValue()) {
      return this.options.find(item => item.value === this.getValue());
    } else {
      return {};
    }
  }

  getValue() {
    return this.selectField.getValue();
  }

  setValue(value, trigger = false) {
    this.currentValue = value;
    this.selectField.setValue(value, trigger);
    value ? $(".selectize-input", this.element).addClass("has-value") : $(".selectize-input", this.element).removeClass("has-value");
  }

  setDisabled(isDisabled = false) {
    if (isDisabled) {
      this.selectField.disable();
    } else {
      this.selectField.enable();
    }
  }

  setLang(newLang, isResetField = false) {
    if (newLang !== this.lang) {
      this.lang = newLang;
      $(`.label-item`, this.element).addClass("hide");
      $(`.label-item.${newLang || "en"}`, this.element).removeClass("hide");

      if (isResetField) {
        this.setupField(true);
      }
    }
  }
}